// Keyboard-shortcut matching for the admin global search palette (Ctrl/Cmd+K).
// Pure function, kept out of the hook so the AltGr/Shift edge cases are
// unit-testable without synthesizing real browser keyboard events.

type KeyComboEvent = Pick<KeyboardEvent, "altKey" | "ctrlKey" | "metaKey" | "shiftKey" | "key">

/**
 * True when the event is a plain Ctrl+K (Windows/Linux) or Cmd+K (macOS).
 *
 * `!altKey` is the AltGr guard — Windows reports AltGr as Ctrl+Alt, so layouts
 * that produce a character with AltGr+K must keep typing it. Shift is rejected
 * too so Ctrl+Shift+K stays free for other bindings.
 */
export function matchAdminSearchShortcut(event: KeyComboEvent): boolean {
  if (event.key.toLowerCase() !== "k") return false
  if (event.altKey || event.shiftKey) return false
  // Exactly one of Ctrl / Cmd — never both.
  return event.ctrlKey !== event.metaKey
}
